module.exports = __webpack_public_path__ + "static/media/AF-Logo-Mark.224fa731.png";